var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"show-modal":_vm.showModal,"width":"40"},on:{"close-modal":_vm.closeModal}},[_c('div',{staticClass:"plain-box"},[_c('button',{staticClass:"absolute transform rotate-90 bg-primary-yellow rounded click-box",on:{"click":function($event){return _vm.$emit('triggerfeedback')}}},[_vm._v("Leave us a feedback")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }